import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-red-100 text-red-800",
  disapproved: "bg-red-100 text-red-800",
  declined: "bg-red-100 text-red-800",
  returned_for_correction: "bg-violet-100 text-violet-800",
  returned: "bg-violet-100 text-violet-800",
  no_further_action_needed: "bg-slate-100 text-slate-700",
  conference_requested: "bg-sky-100 text-sky-800",
  conference_date: "bg-blue-100 text-blue-800",
  conference_completed: "bg-emerald-100 text-emerald-800",
  no_action_yet: "bg-slate-100 text-slate-600",
  rescinded: "bg-slate-200 text-slate-500 line-through",
  merit: "bg-emerald-100 text-emerald-800",
  demerit: "bg-red-100 text-red-800",
  active: "bg-emerald-100 text-emerald-800",
  inactive: "bg-slate-200 text-slate-500",
};

const LABELS = {
  no_action_yet: "Awaiting Acknowledgement",
  no_further_action_needed: "No Further Action",
  conference_requested: "Conference Requested",
  conference_date: "Conference Scheduled",
  conference_completed: "Conference Completed",
  returned_for_correction: "Returned for Correction",
  disapproved: "Declined",
  rescinded: "Repealed",
  active: "Active",
  inactive: "Inactive",
};

export function StatusBadge({ status, className }) {
  if (!status) return null;
  const label = LABELS[status] || status.charAt(0).toUpperCase() + status.slice(1);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        MAP[status] || "bg-slate-100 text-slate-700",
        className
      )}
    >
      {label}
    </span>
  );
}

export default StatusBadge;
